import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingPaymentStatusLabel',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  status: string;
};



const statuses: Record<string, string> = {
  "paid": "Paid",
  "onaccount": "On Account",
  "partially": "Partially",
  "paydriver": "Will pay driver",
  "autopay": "Autopay",
  "cancelled": "Cancelled",
  "confirmed": "Confirmed",
}

const statusCss = computed(() => {
  return `car-payment-status--${props.status}`
})

const statusText = computed(() => {
  return props.status in statuses ? statuses[props.status] : props.status;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["car-payment-status", _unref(statusCss)])
  }, _toDisplayString(_unref(statusText)), 3))
}
}

})